export default [
  {
    path: '/apps/cliente-tipo-pedido/list',
    name: 'apps-cliente-tipo-pedido-list',
    component: () => import('@/views/cadastros/cliente/cliente-tipo-pedido/list/Index.vue'),
    meta: {
      pageTitle: 'Cliente X Tipo Pedido',
    },
  },
];
